import { useMemo, useState } from "react";
import TableRowProductSupplierResponsesRow from "./product-supplier-responses-row/product-supplier-responses-row";
import TableRowProductSupplierResponsesHeader from "./product-supplier-responses-header/product-supplier-responses-header";
import ProductCollapseRow from "./product-collapse-row/product-collapse-row";
import { ISpecificationSupplierProduct } from "@/shared/services/interface/responses/ISupplierResponsesAllResponse";
import { mapProductToRows } from "./utils/product-supplier-responses-utils";

interface TableRowProductSupplierResponsesProps {
  index: number;
  product: ISpecificationSupplierProduct;
}

export default function TableRowProductSupplierResponses({
  product,
  index,
}: TableRowProductSupplierResponsesProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const rows = useMemo(() => mapProductToRows(product), [product]);
  const progressCurrent = product.totalSuppliersCount;
  const progressTotal =
    product.suppliers.length > 0
      ? product.suppliers.length
      : product.totalSuppliersCount || 1;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      {/* Product collapse row */}
      <ProductCollapseRow
        productName={product.productName}
        productLogo={product.logoSrc || undefined}
        progressCurrent={progressCurrent}
        progressTotal={progressTotal}
        isExpanded={isExpanded}
        onToggle={handleToggle}
      />

      {/* Collapsible content */}
      {isExpanded && (
        <div className="border-b border-border">
          <TableRowProductSupplierResponsesHeader />
          {rows.map((item) => (
            <TableRowProductSupplierResponsesRow key={item.id} item={item} />
          ))}
        </div>
      )}
    </>
  );
}
